import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const TestimonyContainer = styled.div`
  padding: 4rem 2rem;
  max-width: 1220px !important;

  & > div {
    display: grid;
    column-gap: 8.5rem;
    grid-template-columns: 400px 1fr;

    @media all and (max-width: ${layout.lg}) {
      grid-template-columns: 30% 1fr;
    }

    @media all and (max-width: ${layout.subMd}) {
      grid-template-columns: 1fr;
    }
  }
`

export const TestimonyText = styled.div`
  display: grid;
  row-gap: 1.5rem;
  align-self: center;
  position:  relative;

  &::after {
    content: ' ';
    position: absolute;
    width: 33px;
    height: 165px;
    top: 16%;
    left: -80px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMTY1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yMi4zNSA3My45MTNsLTIwLjYwNC0yLjggMTcuMTggMjAuMDY5IDMuNDI0LTE3LjI2OXoiIGZpbGw9IiNGRjcwNjIiLz48cGF0aCBkPSJNMjIuNjA0IDQ3LjI2OUwyIDUwLjA2OSAxOS4xOCAzMGwzLjQyNCAxNy4yNjl6IiBmaWxsPSIjRjFCNkIwIi8+PHBhdGggZD0iTTI2LjkyNyAyLjU1N0w3LjA5IDE1LjM3OS44OTYgOC44MSAxLjkyIDEuOTI1bDI1LjAwNy42M3oiIGZpbGw9IiM5NjM0ODEiLz48cGF0aCBkPSJNMjQuMzUgMTU0LjI2OWwtMjAuNjA0IDIuNzk5TDIwLjkyNiAxMzdsMy40MjQgMTcuMjY5eiIgZmlsbD0iIzFDQUJCRiIvPjxwYXRoIGQ9Ik0yOC45MjcgMTA5LjU1N0w5LjA5IDEyMi4zNzlsLTYuMTk0LTYuNTcxIDEuMDI0LTYuODgyIDI1LjAwNy42MzF6IiBmaWxsPSIjRkZERjZFIi8+PC9zdmc+);
  }

  @media all and (max-width: ${layout.subMd}) {
    &::after {
      display: none;
    }
    &::before {
      width: 100%;
      height: 40px;
      display: block;
      text-align: center;
      content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTczLjkxMyA4Ljk1bC0yLjggMjAuNjAzIDIwLjA2OS0xNy4xOC0xNy4yNy0zLjQyM3oiIGZpbGw9IiNGRjcwNjIiLz48cGF0aCBkPSJNNDcuMjY3IDguNjk0bDIuOCAyMC42MDMtMjAuMDY5LTE3LjE4IDE3LjI3LTMuNDIzeiIgZmlsbD0iI0YxQjZCMCIvPjxwYXRoIGQ9Ik0yLjU1NyA0LjM3MkwxNS4zNzkgMjQuMjFsLTYuNTcgNi4xOTQtNi44ODMtMS4wMjQuNjMtMjUuMDA3eiIgZmlsbD0iIzgwRDFDRCIvPjwvc3ZnPg==);
      margin-bottom: -10px;
      margin-top: 8px;
    }
    p, h1 {
      text-align: center;
    }
  }
`

export const TestimonyImage = styled.div`
  display: grid;
  width: 100%;

  @media all and (max-width: ${layout.subMd}) {
    width: 200px;
    justify-self: center;
  }
`
